import React, { PropsWithChildren, useState } from "react";

import Grid from "@material-ui/core/Grid";
import { DateTimePicker } from '@material-ui/pickers';

import { ActionFilterButtonWithDialog } from "../../../components";
import useReservationFilterStyle from './service_reservations_filters.style';

export type ServiceReservationFilterValue = {
  from: Date;
  to: Date;
  serviceId?: string;
}

export interface ReservationFiltersProps extends PropsWithChildren<{}> {
  value: ServiceReservationFilterValue;
  setValue: (v: ServiceReservationFilterValue) => void;
}

function ServiceReservationsFilters(props: ReservationFiltersProps) {
  const { value, setValue, children } = props;

  const classes = useReservationFilterStyle();

  const [from, setFrom] = useState<Date>(value.from);
  const [to, setTo] = useState<Date>(value.to);

  const onConfirmClick = () => {
    setValue({
      ...value,
      from,
      to
    });
  }

  return <ActionFilterButtonWithDialog
    onConfirmClick={onConfirmClick}
  >
    <Grid container spacing={3}>
      <Grid item sm={4} xs={12}>
        <DateTimePicker
          ampm={false}
          clearable={false}
          format="dd/MM/yyyy HH:mm"
          className={classes.fullWidth}
          label="Dal"
          inputVariant="outlined"
          value={from}
          onChange={(e) => setFrom(e as Date)}
        />
      </Grid>
      <Grid item sm={4} xs={12}>
        <DateTimePicker
          ampm={false}
          clearable={false}
          format="dd/MM/yyyy HH:mm"
          className={classes.fullWidth}
          label="Al"
          inputVariant="outlined"
          value={to}
          onChange={(e) => setTo(e as Date)}
        />
      </Grid>
    </Grid>
    {children}
  </ActionFilterButtonWithDialog>
}

export { ServiceReservationsFilters }
